import { mkJsonTransformer } from "../utils/jsonTransformer";
const toBigInt = (v) => BigInt(v);
export const quickblueTxOutJsonTransformer = mkJsonTransformer({
    items: { value: { quantity: toBigInt } }
});
export function toCardanoTxOut(qout) {
    return {
        txHash: qout.txHash,
        index: qout.index,
        value: qout.value,
        addr: qout.addr,
        dataHash: qout.dataHash,
        dataBin: qout.dataBin
    };
}
export function toCardanoTxIn(qin) {
    return { outTxHash: qin.out.txHash, outIndex: qin.out.index };
}
export function toCardanoTx(qtx) {
    return {
        hash: qtx.hash,
        inputs: qtx.inputs.map(i => toCardanoTxIn(i)),
        outputs: qtx.outputs.map(o => toCardanoTxOut(o)),
        validityRange: [qtx.invalidBefore, qtx.invalidHereafter]
    };
}
export const quickblueNetworkParamsTransformer = mkJsonTransformer({
    pparams: {
        txFeeFixed: toBigInt,
        txFeePerByte: toBigInt,
        stakeAddressDeposit: toBigInt,
        stakePoolDeposit: toBigInt,
        utxoCostPerWord: toBigInt
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kZWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3F1aWNrYmx1ZS9tb2RlbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0EsT0FBTyxFQUFDLGlCQUFpQixFQUFDLE1BQU0sMEJBQTBCLENBQUE7QUFnQjFELE1BQU0sUUFBUSxHQUFHLENBQUMsQ0FBUyxFQUFFLEVBQUUsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFFekMsTUFBTSxDQUFDLE1BQU0sNkJBQTZCLEdBQUcsaUJBQWlCLENBQXdCO0lBQ3BGLEtBQUssRUFBRSxFQUFDLEtBQUssRUFBRSxFQUFDLFFBQVEsRUFBRSxRQUFRLEVBQUMsRUFBQztDQUNyQyxDQUFDLENBQUE7QUFFRixNQUFNLFVBQVUsY0FBYyxDQUFDLElBQW9CO0lBQ2pELE9BQU87UUFDTCxNQUFNLEVBQUUsSUFBSSxDQUFDLE1BQU07UUFDbkIsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLO1FBQ2pCLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSztRQUNqQixJQUFJLEVBQUUsSUFBSSxDQUFDLElBQUk7UUFDZixRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVE7UUFDdkIsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPO0tBQ3RCLENBQUE7QUFDSCxDQUFDO0FBaUJELE1BQU0sVUFBVSxhQUFhLENBQUMsR0FBa0I7SUFDOUMsT0FBTyxFQUFDLFNBQVMsRUFBRSxHQUFHLENBQUMsR0FBRyxDQUFDLE1BQU0sRUFBRSxRQUFRLEVBQUUsR0FBRyxDQUFDLEdBQUcsQ0FBQyxLQUFLLEVBQUMsQ0FBQTtBQUM3RCxDQUFDO0FBbUJELE1BQU0sVUFBVSxXQUFXLENBQUMsR0FBZ0I7SUFDMUMsT0FBTztRQUNMLElBQUksRUFBRSxHQUFHLENBQUMsSUFBSTtRQUNkLE1BQU0sRUFBRSxHQUFHLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUM3QyxPQUFPLEVBQUUsR0FBRyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDaEQsYUFBYSxFQUFFLENBQUMsR0FBRyxDQUFDLGFBQWEsRUFBRSxHQUFHLENBQUMsZ0JBQWdCLENBQUM7S0FDekQsQ0FBQTtBQUNILENBQUM7QUFnQkQsTUFBTSxDQUFDLE1BQU0saUNBQWlDLEdBQUcsaUJBQWlCLENBQWlCO0lBQ2pGLE9BQU8sRUFBRTtRQUNQLFVBQVUsRUFBRSxRQUFRO1FBQ3BCLFlBQVksRUFBRSxRQUFRO1FBQ3RCLG1CQUFtQixFQUFFLFFBQVE7UUFDN0IsZ0JBQWdCLEVBQUUsUUFBUTtRQUMxQixlQUFlLEVBQUUsUUFBUTtLQUMxQjtDQUNGLENBQUMsQ0FBQSJ9